import { render, staticRenderFns } from "./JeecgOrderMainModal.vue?vue&type=template&id=31bd0713&scoped=true"
import script from "./JeecgOrderMainModal.vue?vue&type=script&lang=js"
export * from "./JeecgOrderMainModal.vue?vue&type=script&lang=js"
import style0 from "./JeecgOrderMainModal.vue?vue&type=style&index=0&id=31bd0713&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd0713",
  null
  
)

export default component.exports